import React, { useState, useEffect } from 'react'
import { Button, Image, Label, Form } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import './Login.scss'
import { Link } from 'react-router-dom'
import logo_facebook from '../../../assets/logo_facebook.svg'
import google from '../../../assets/google.svg'
import twitter from '../../../assets/twitter.svg'
import { signIn, signInWithSocialMedia } from '../../../redux/actions/auth'



const Login = props => {

    const { authError, uid } = props; // obten tambien el uid
    const [credentials, setCredentials] = useState({
        email: '',
        password: ''
    });

    useEffect(() => {
        if(uid) {
            props.history.push('/')
        }
    }, [uid])

    const goToRecoverPassword = () => {
        props.history.push('/recover_password')
    }

    const handleOnChange = e => {

        const { name, value } = e.target;
        setCredentials({
            ...credentials,
            [name]: value
        })

    }

    const handleOnSubmit = e => {

        e.preventDefault();
        console.log(credentials)
        props.signIn(credentials)

    }

    return (
        <div className='login'>
            <div className='content'>
                <Label>
                    Necesita iniciar sesión o <Link to='/signup'> registrar </Link>
                    una cuenta para continuar
                </Label>
                <div className='content_social'>
                    <Button className='content_social_facebook' onClick={() => props.signInWithSocialMedia('facebook')}>
                        <Image src={logo_facebook}/>
                        Continuar con Facebook
                    </Button>
                    <Button className='content_social_google' onClick={() => props.signInWithSocialMedia('google')}>
                        <Image src={google}/>
                        Continuar con Google
                    </Button>
                    <Button className='content_social_twitter' onClick={() => props.signInWithSocialMedia('twitter')}>
                        <Image src={twitter}/>
                        Continuar con Twitter
                    </Button>
                </div>

                <label>O inicia sesión con</label>

                <Form onSubmit={handleOnSubmit}>
                    <Form.Field>
                        <input 
                            placeholder='Email' 
                            type='email' 
                            name='email' 
                            autoComplete='off'
                            onChange={handleOnChange}  />
                    </Form.Field>
                    <Form.Field>
                        <input 
                            placeholder='Contraseña' 
                            type='password' 
                            name='password' 
                            autoComplete='off'
                            onChange={handleOnChange} />
                    </Form.Field>

                    <div className='actions'>
                        <label onClick={goToRecoverPassword}>¿Olvidaste tu contraseña?</label>
                        <Button type='submit'>Iniciar sesión</Button>
                    </div>
                    {
                        authError ? 
                        <h4 style={{ color: 'red', textAlign: 'center' }}>
                            {authError}
                        </h4> : null
                    }

                    <div className='account'>
                        <label>¿No tienes una cuenta?</label>
                        <Link to='/signup'>Crear una</Link>
                    </div>
                </Form>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    
    const uid = state.auth.uid
    const authError = state.auth.authError;

    return {
        uid,
        authError
    }
}

const mapDispatchToProps = dispatch => {
    return {
        signIn: credentials => dispatch(signIn(credentials)),
        signInWithSocialMedia: idSocial => dispatch(signInWithSocialMedia(idSocial))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login))
